module.exports = vendors_ru_f81a5dcffb340f7fde80;